// extracted by mini-css-extract-plugin
export default {"root":"ChatPage_root__tp+MI","listPane":"ChatPage_listPane__GQwSx","viewPane":"ChatPage_viewPane__kZMRX"};